module.exports = __webpack_public_path__ + "img/side-icon-54-off.8518b5e2.svg";